import { UseCase } from './UseCase';
import { Sound } from '../entities/sound';
import { SupportedSound } from '../entities/SoundType';
export class PlayerWhistleUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.interface.playSound(new Sound(SupportedSound.WHISTLE));
    }
}
